module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.09.26-3.a751b9b5.jpg";